<template>
  <g
    id="Back_wheel"
    v-on:click="changeSeverity('rearBackWheel')"
    :class="severityClass"
  >
    <rect
      class="cls-611"
      x="24.79"
      y="288.49"
      width="72.32"
      height="20.49"
      rx="10.24"
      ry="10.24"
      transform="translate(359.69 237.79) rotate(90)"
    />
    <rect class="cls-526" x="51.02" y="270.76" width="1.7" height="42.28" />
    <path
      class="cls-526"
      d="M51.87,323.96h0c.47,0,.85-.38,.85-.85v-10.39c0-.47-.38-.85-.85-.85h0c-.47,0-.85,.38-.85,.85v10.39c0,.47,.38,.85,.85,.85Z"
    />
    <rect class="cls-526" x="69.18" y="270.76" width="1.7" height="42.28" />
    <path
      class="cls-526"
      d="M70.03,323.96h0c-.47,0-.85-.38-.85-.85v-10.39c0-.47,.38-.85,.85-.85h0c.47,0,.85,.38,.85,.85v10.39c0,.47-.38,.85-.85,.85Z"
    />
    <rect class="cls-901" x="44.18" y="309.91" width="32.55" height="4.29" />
    <g>
      <path
        class="cls-905"
        d="M68.71,281.18c1.1-.26,2.11-.34,2.85-.28,.14,.01,.25,.12,.28,.25l.27,1.14,5.63,24.05c.25,1.08,.37,2.18,.35,3.29l-.05,2.71-3.79,.89-1.24-2.41c-.51-.98-.89-2.02-1.14-3.1l-5.62-24.01-.28-1.18c-.03-.13,.02-.27,.14-.35,.62-.39,1.52-.74,2.6-.99Z"
      />
      <rect
        class="cls-906"
        x="73.59"
        y="309.41"
        width="4.83"
        height="5.42"
        rx="1.23"
        ry="1.23"
        transform="translate(221.18 598.68) rotate(166.82)"
      />
    </g>
    <g>
      <path
        class="cls-895"
        d="M53.31,281.21c1.09,.26,2.04,.64,2.68,1.03,.12,.07,.17,.22,.14,.35l-.27,1.13-5.79,24.01c-.26,1.07-.65,2.11-1.16,3.09l-1.26,2.4-3.78-.91-.03-2.71c-.01-1.11,.11-2.21,.37-3.28l5.78-23.98,.28-1.17c.03-.13,.14-.24,.28-.25,.73-.07,1.69,.02,2.77,.28Z"
      />
      <rect
        class="cls-894"
        x="43.49"
        y="309.41"
        width="4.83"
        height="5.42"
        rx="1.23"
        ry="1.23"
        transform="translate(17.37 626.3) rotate(-166.44)"
      />
    </g>
    <g>
      <path
        class="cls-893"
        d="M68.56,276.66v70.42c0,1.27-.24,2.48-.65,3.55-.08,.22-.17,.43-.27,.64-.04,.07-.07,.15-.12,.22-1,1.95-2.66,3.31-4.59,3.55-.05,.01-.1,.02-.15,.02-.02,0-.04,0-.06,0-.17,.02-.34,.03-.5,.04h0c-.85,.05-1.71,.05-2.56,0-.16-.01-.32-.03-.48-.04-.04,0-.07,0-.1-.01-.05,0-.11-.01-.16-.02-1.88-.26-3.5-1.58-4.5-3.48-.04-.07-.09-.16-.12-.24-.1-.21-.19-.42-.28-.63-.43-1.09-.67-2.32-.67-3.62v-70.42c0-.31,.02-.62,.04-.92,.06-.65,.18-1.27,.35-1.86,.01-.05,.03-.1,.04-.15,.04-.14,.09-.29,.14-.43,.76-2.12,2.23-3.74,4.02-4.37,.04-.02,.09-.03,.13-.04,.16-.05,.33-.1,.5-.13,.2-.04,.41-.07,.61-.09,1.18-.1,2.36-.1,3.55,0,.19,.02,.38,.04,.56,.09,.17,.03,.34,.07,.5,.12,.04,.02,.09,.03,.13,.04,1.79,.61,3.26,2.22,4.03,4.32,.05,.14,.1,.29,.15,.43,.02,.05,.03,.1,.04,.15,.18,.6,.3,1.23,.36,1.88,.03,.32,.05,.63,.05,.96Z"
      />
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M62.28,347.21c2.36-3.19,6.06-4.54,6.21-4.6,.02,0,.04-.01,.07-.01v.65c-.51,.2-3.83,1.57-5.93,4.41-.09,.13-.25,.13-.35,.01-.1-.12-.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M62.28,347.21s-.05,.08-.06,.13c.01,.05,.03,.11,.06,.15,.1,.12,.25,.11,.35-.01,2.1-2.83,5.41-4.2,5.93-4.41v-.47s-.04,0-.07,.01c-.16,.06-3.85,1.42-6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M62.28,339.48c2.36-3.19,6.06-4.54,6.21-4.6,.02,0,.04-.01,.07-.01v.65c-.51,.2-3.83,1.57-5.93,4.41-.09,.13-.25,.13-.35,.01-.1-.12-.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M62.28,339.48s-.05,.08-.06,.13c.01,.05,.03,.11,.06,.15,.1,.12,.25,.11,.35-.01,2.1-2.83,5.41-4.2,5.93-4.41v-.47s-.04,0-.07,.01c-.16,.06-3.85,1.42-6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M62.28,331.74c2.36-3.19,6.06-4.54,6.21-4.6,.02,0,.04-.01,.07-.01v.65c-.51,.2-3.83,1.57-5.93,4.41-.09,.13-.25,.13-.35,.01-.1-.12-.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M62.28,331.74s-.05,.08-.06,.13c.01,.05,.03,.11,.06,.15,.1,.12,.25,.11,.35-.01,2.1-2.83,5.41-4.2,5.93-4.41v-.47s-.04,0-.07,.01c-.16,.06-3.85,1.42-6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M62.28,324.01c2.36-3.19,6.06-4.54,6.21-4.6,.02,0,.04-.01,.07-.01v.65c-.51,.2-3.83,1.57-5.93,4.41-.09,.13-.25,.13-.35,.01-.1-.12-.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M62.28,324.01s-.05,.08-.06,.13c.01,.05,.03,.11,.06,.15,.1,.12,.25,.11,.35-.01,2.1-2.83,5.41-4.2,5.93-4.41v-.47s-.04,0-.07,.01c-.16,.06-3.85,1.42-6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M62.28,316.28c2.36-3.19,6.06-4.54,6.21-4.6,.02,0,.04-.01,.07-.01v.65c-.51,.2-3.83,1.57-5.93,4.41-.09,.13-.25,.13-.35,.01-.1-.12-.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M62.28,316.28s-.05,.08-.06,.13c.01,.05,.03,.11,.06,.15,.1,.12,.25,.11,.35-.01,2.1-2.83,5.41-4.2,5.93-4.41v-.47s-.04,0-.07,.01c-.16,.06-3.85,1.42-6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M62.28,308.55c2.36-3.19,6.06-4.54,6.21-4.6,.02,0,.04-.01,.07-.01v.65c-.51,.2-3.83,1.57-5.93,4.41-.09,.13-.25,.13-.35,.01-.1-.12-.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M62.28,308.55s-.05,.08-.06,.13c.01,.05,.03,.11,.06,.15,.1,.12,.25,.11,.35-.01,2.1-2.83,5.41-4.2,5.93-4.41v-.47s-.04,0-.07,.01c-.16,.06-3.85,1.42-6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M62.28,300.81c2.36-3.19,6.06-4.54,6.21-4.6,.02,0,.04-.01,.07-.01v.65c-.51,.2-3.83,1.57-5.93,4.41-.09,.13-.25,.13-.35,.01-.1-.12-.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M62.28,300.81s-.05,.08-.06,.13c.01,.05,.03,.11,.06,.15,.1,.12,.25,.11,.35-.01,2.1-2.83,5.41-4.2,5.93-4.41v-.47s-.04,0-.07,.01c-.16,.06-3.85,1.42-6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M62.28,293.08c2.36-3.19,6.06-4.54,6.21-4.6,.02,0,.04-.01,.07-.01v.65c-.51,.2-3.83,1.57-5.93,4.41-.09,.13-.25,.13-.35,.01-.1-.12-.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M62.28,293.08s-.05,.08-.06,.13c.01,.05,.03,.11,.06,.15,.1,.12,.25,.11,.35-.01,2.1-2.83,5.41-4.2,5.93-4.41v-.47s-.04,0-.07,.01c-.16,.06-3.85,1.42-6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M62.28,285.35c2.36-3.19,6.06-4.54,6.21-4.6,.02,0,.04-.01,.07-.01v.65c-.51,.2-3.83,1.57-5.93,4.41-.09,.13-.25,.13-.35,.01-.1-.12-.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M62.28,285.35s-.05,.08-.06,.13c.01,.05,.03,.11,.06,.15,.1,.12,.25,.11,.35-.01,2.1-2.83,5.41-4.2,5.93-4.41v-.47s-.04,0-.07,.01c-.16,.06-3.85,1.42-6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M68.15,273.81c-.65,.29-1.89,.9-3.17,1.88-.82,.63-1.65,1.41-2.35,2.35-.1,.12-.25,.13-.35,.01-.07-.09-.09-.21-.06-.32,0-.02,.01-.04,.02-.07,.01-.02,.02-.04,.04-.06,.55-.73,1.16-1.37,1.79-1.92,1.51-1.33,3.09-2.11,3.9-2.47,.05,.14,.1,.29,.15,.43,.02,.05,.03,.1,.04,.15Z"
          />
        </g>
        <path
          class="cls-566"
          d="M68.11,273.66c-.7,.32-2.02,.98-3.34,2.03-.75,.6-1.5,1.32-2.13,2.18-.1,.13-.25,.13-.35,.01-.03-.04-.05-.1-.06-.15,0-.02,.01-.04,.02-.07,.01-.02,.02-.04,.04-.06,.55-.73,1.16-1.37,1.79-1.92,1.51-1.33,3.09-2.11,3.9-2.47,.05,.14,.1,.29,.15,.43Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M59.63,347.26c-2.36-3.19-6.06-4.54-6.21-4.6-.02,0-.04-.01-.07-.01v.65c.51,.2,3.83,1.57,5.93,4.41,.09,.13,.25,.13,.35,.01,.1-.12,.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M59.63,347.26s.05,.08,.06,.13c-.01,.05-.03,.11-.06,.15-.1,.12-.25,.11-.35-.01-2.1-2.83-5.41-4.2-5.93-4.41v-.47s.04,0,.07,.01c.16,.06,3.85,1.42,6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M59.63,339.53c-2.36-3.19-6.06-4.54-6.21-4.6-.02,0-.04-.01-.07-.01v.65c.51,.2,3.83,1.57,5.93,4.41,.09,.13,.25,.13,.35,.01,.1-.12,.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M59.63,339.53s.05,.08,.06,.13c-.01,.05-.03,.11-.06,.15-.1,.12-.25,.11-.35-.01-2.1-2.83-5.41-4.2-5.93-4.41v-.47s.04,0,.07,.01c.16,.06,3.85,1.42,6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M67.91,350.63c-.08,.22-.17,.43-.27,.63-.04,.08-.07,.15-.11,.22-1.19,.6-3.12,1.75-4.59,3.55-.05,0-.1,.02-.15,.02-.02,0-.04,0-.06,0-.17,.02-.33,.03-.5,.04,0,0,0,.01,0,.02,0,0,0-.01,0-.02,0-.02,0-.03,.02-.05,0-.02,.02-.04,.03-.06,1.84-2.47,4.47-3.84,5.63-4.36Z"
          />
        </g>
        <path
          class="cls-566"
          d="M67.91,350.63c-.08,.22-.17,.43-.27,.63-1.22,.6-3.32,1.83-4.85,3.79-.02,0-.04,0-.06,0-.17,.02-.33,.03-.5,.04,0-.02,0-.03,.02-.05,0-.02,.02-.04,.03-.06,1.84-2.47,4.47-3.84,5.63-4.36Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M59.63,355.04s.02,.04,.03,.06c-.16-.01-.32-.03-.48-.04-.03,0-.07,0-.1-.01-.05,0-.1,0-.16-.02-1.45-1.75-3.32-2.88-4.5-3.47h0c-.04-.08-.08-.16-.12-.24-.1-.21-.19-.41-.28-.63,1.17,.52,3.79,1.89,5.61,4.35Z"
          />
        </g>
        <path
          class="cls-566"
          d="M59.66,355.1c-.16-.01-.32-.03-.48-.04-.03,0-.07,0-.1-.01-1.52-1.92-3.57-3.13-4.78-3.73-.1-.21-.19-.41-.28-.63,1.17,.52,3.79,1.89,5.61,4.35,.01,.02,.02,.04,.03,.06Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M59.63,331.79c-2.36-3.19-6.06-4.54-6.21-4.6-.02,0-.04-.01-.07-.01v.65c.51,.2,3.83,1.57,5.93,4.41,.09,.13,.25,.13,.35,.01,.1-.12,.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M59.63,331.79s.05,.08,.06,.13c-.01,.05-.03,.11-.06,.15-.1,.12-.25,.11-.35-.01-2.1-2.83-5.41-4.2-5.93-4.41v-.47s.04,0,.07,.01c.16,.06,3.85,1.42,6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M59.63,324.06c-2.36-3.19-6.06-4.54-6.21-4.6-.02,0-.04-.01-.07-.01v.65c.51,.2,3.83,1.57,5.93,4.41,.09,.13,.25,.13,.35,.01,.1-.12,.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M59.63,324.06s.05,.08,.06,.13c-.01,.05-.03,.11-.06,.15-.1,.12-.25,.11-.35-.01-2.1-2.83-5.41-4.2-5.93-4.41v-.47s.04,0,.07,.01c.16,.06,3.85,1.42,6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M59.63,316.33c-2.36-3.19-6.06-4.54-6.21-4.6-.02,0-.04-.01-.07-.01v.65c.51,.2,3.83,1.57,5.93,4.41,.09,.13,.25,.13,.35,.01,.1-.12,.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M59.63,316.33s.05,.08,.06,.13c-.01,.05-.03,.11-.06,.15-.1,.12-.25,.11-.35-.01-2.1-2.83-5.41-4.2-5.93-4.41v-.47s.04,0,.07,.01c.16,.06,3.85,1.42,6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M59.63,308.59c-2.36-3.19-6.06-4.54-6.21-4.6-.02,0-.04-.01-.07-.01v.65c.51,.2,3.83,1.57,5.93,4.41,.09,.13,.25,.13,.35,.01,.1-.12,.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M59.63,308.59s.05,.08,.06,.13c-.01,.05-.03,.11-.06,.15-.1,.12-.25,.11-.35-.01-2.1-2.83-5.41-4.2-5.93-4.41v-.47s.04,0,.07,.01c.16,.06,3.85,1.42,6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M59.63,300.86c-2.36-3.19-6.06-4.54-6.21-4.6-.02,0-.04-.01-.07-.01v.65c.51,.2,3.83,1.57,5.93,4.41,.09,.13,.25,.13,.35,.01,.1-.12,.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M59.63,300.86s.05,.08,.06,.13c-.01,.05-.03,.11-.06,.15-.1,.12-.25,.11-.35-.01-2.1-2.83-5.41-4.2-5.93-4.41v-.47s.04,0,.07,.01c.16,.06,3.85,1.42,6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M59.63,293.13c-2.36-3.19-6.06-4.54-6.21-4.6-.02,0-.04-.01-.07-.01v.65c.51,.2,3.83,1.57,5.93,4.41,.09,.13,.25,.13,.35,.01,.1-.12,.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M59.63,293.13s.05,.08,.06,.13c-.01,.05-.03,.11-.06,.15-.1,.12-.25,.11-.35-.01-2.1-2.83-5.41-4.2-5.93-4.41v-.47s.04,0,.07,.01c.16,.06,3.85,1.42,6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M59.63,285.4c-2.36-3.19-6.06-4.54-6.21-4.6-.02,0-.04-.01-.07-.01v.65c.51,.2,3.83,1.57,5.93,4.41,.09,.13,.25,.13,.35,.01,.1-.12,.1-.32,0-.45Z"
          />
        </g>
        <path
          class="cls-566"
          d="M59.63,285.4s.05,.08,.06,.13c-.01,.05-.03,.11-.06,.15-.1,.12-.25,.11-.35-.01-2.1-2.83-5.41-4.2-5.93-4.41v-.47s.04,0,.07,.01c.16,.06,3.85,1.42,6.21,4.6Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M59.62,278.14c-.1,.12-.25,.11-.35-.02-.73-.98-1.6-1.78-2.45-2.42-1.25-.95-2.46-1.54-3.09-1.82,.01-.05,.03-.1,.04-.15,.04-.14,.09-.29,.14-.43,.78,.34,2.33,1.11,3.84,2.4,.65,.56,1.3,1.23,1.87,1.99,.02,.02,.03,.04,.04,.06,.01,.02,.02,.04,.02,.07,.03,.11,0,.24-.06,.32Z"
          />
        </g>
        <path
          class="cls-566"
          d="M59.68,277.82c-.01,.05-.03,.11-.06,.15-.1,.12-.25,.11-.35-.02-.66-.89-1.44-1.64-2.23-2.25-1.3-1.02-2.58-1.66-3.27-1.97,.04-.14,.09-.29,.14-.43,.78,.34,2.33,1.11,3.84,2.4,.65,.56,1.3,1.23,1.87,1.99,.02,.02,.03,.04,.04,.06,.01,.02,.02,.04,.02,.07Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M63.93,268.91c-.45,.43-.9,.92-1.29,1.46-.1,.13-.25,.13-.35,.01-.07-.09-.09-.21-.06-.32,0-.02,.01-.04,.02-.07,.01-.02,.02-.04,.04-.06,.32-.43,.66-.82,1.01-1.18,.17,.03,.34,.07,.5,.12,.04,.02,.09,.03,.13,.04Z"
          />
        </g>
        <path
          class="cls-566"
          d="M63.79,268.87c-.41,.4-.8,.84-1.16,1.33-.1,.13-.25,.13-.35,.01-.03-.04-.05-.09-.06-.15,0-.02,.01-.04,.02-.07,.01-.02,.02-.04,.04-.06,.32-.43,.66-.82,1.01-1.18,.17,.03,.34,.07,.5,.12Z"
        />
      </g>
      <g>
        <g class="cls-738">
          <path
            class="cls-22"
            d="M59.62,270.43c-.1,.12-.25,.11-.35-.01-.41-.55-.86-1.05-1.33-1.49,.04-.02,.09-.03,.13-.04,.16-.05,.33-.1,.5-.13,.37,.37,.73,.78,1.05,1.23,.02,.02,.03,.04,.04,.06,.01,.02,.02,.05,.02,.07,.03,.11,0,.24-.06,.32Z"
          />
        </g>
        <path
          class="cls-566"
          d="M59.68,270.11c-.01,.05-.03,.11-.06,.15-.1,.12-.25,.11-.35-.01-.37-.5-.78-.95-1.2-1.36,.16-.05,.33-.1,.5-.13,.37,.37,.73,.78,1.05,1.23,.02,.02,.03,.04,.04,.06,.01,.02,.02,.05,.02,.07Z"
        />
      </g>
    </g>
    <path
      class="cls-533"
      d="M52.72,270.76v5.14c-.75,.28-1.36,.85-1.7,1.58v-5.32c.14-.49,.34-.96,.58-1.4h1.12Z"
    />
    <path
      class="cls-533"
      d="M68.15,273.81c.18,.6,.3,1.23,.36,1.88h-14.68c-.15,0-.3,.01-.44,.04,.06-.65,.18-1.27,.35-1.86,.01-.05,.03-.1,.04-.15,.04-.14,.09-.29,.14-.43,.76-2.12,2.23-3.74,4.02-4.37,.04-.02,.09-.03,.13-.04,.16-.05,.33-.1,.5-.13,.2-.04,.41-.07,.61-.09,1.18-.1,2.36-.1,3.55,0,.19,.02,.38,.04,.56,.09,.17,.03,.34,.07,.5,.12,.04,.02,.09,.03,.13,.04,1.79,.61,3.26,2.22,4.03,4.32,.05,.14,.1,.29,.15,.43,.02,.05,.03,.1,.04,.15Z"
    />
    <path
      class="cls-533"
      d="M70.88,270.76v5.08c-.29-.1-.61-.14-.94-.14h-.77v-4.93h1.7Z"
    />
    <path
      class="cls-201"
      d="M72.13,269.34v4.49h-.93c0-1.19-1-2.15-2.19-2.15h-16.12c-1.19,0-2.19,.96-2.19,2.15h-.93s0-4.49,0-4.49c0-4.17,3.39-7.56,7.57-7.56h7.22c4.18,0,7.57,3.39,7.57,7.56Z"
    />
    <path
      class="cls-45"
      d="M64.56,261.77h-7.23c-4.18,0-7.56,3.39-7.56,7.56v4.49c0-1.72,1.4-3.11,3.12-3.11h16.12c1.72,0,3.11,1.39,3.11,3.11v-2.26s0-2.23,0-2.23c0-4.18-3.39-7.56-7.56-7.56Z"
    />
    <path
      class="cls-201"
      d="M72.13,269.34v39.07c0,4.18-3.39,7.57-7.57,7.57h-7.22c-4.18,0-7.57-3.39-7.57-7.57v-39.07c0-4.17,3.39-7.56,7.57-7.56h7.22c4.18,0,7.57,3.39,7.57,7.56Z"
    />
  </g>
</template>

<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
